import { ACH, CARD, IPaymentsFeeStructure } from './constants';

export const getParsedConvenienceFee = (
  type: string,
  isDebitCard: boolean,
  amountToPay: number,
  fees: IPaymentsFeeStructure,
): number => {
  const withoutPercentage = (fee: string) => {
    const [first] = fee.split('%');
    return Number(first);
  };

  if (type === ACH) {
    return Number(fees.bankAccount);
  }

  if (type === CARD && isDebitCard) {
    if (fees.debitCard.includes('%')) {
      return (amountToPay * withoutPercentage(fees.debitCard)) / 100;
    }
    return Number(fees.debitCard);
  }

  if (fees.creditCard.includes('%')) {
    return (amountToPay * withoutPercentage(fees.creditCard)) / 100;
  }

  return Number(fees.creditCard);
};

export const calculatePaymentFees = (
  amount: number,
  paymentMethod: any,
  feeStructure: IPaymentsFeeStructure | null,
  property?: any,
) => {
  if (!feeStructure || !paymentMethod) {
    return {
      fee: 0,
      feeType: 'fixed' as const,
      total: amount,
      convenienceFee: 0,
    };
  }

  const type = paymentMethod.type?.toLowerCase() || 'card';
  const isDebitCard = Boolean(paymentMethod.isDebitCard) ||
    type.includes('debit') ||
    paymentMethod.brand?.toLowerCase().includes('debit');

  const convenienceFee = getParsedConvenienceFee(
    type === 'ach' ? ACH : CARD,
    isDebitCard,
    amount,
    feeStructure,
  );

  return {
    fee: Number(convenienceFee.toFixed(2)),
    feeType: feeStructure.creditCard.includes('%') || feeStructure.debitCard.includes('%') ? 'percentage' as const : 'fixed' as const,
    total: Number((amount + convenienceFee).toFixed(2)),
    convenienceFee: Number(convenienceFee.toFixed(2)),
  };
};

export const transformFeeStructureDollarSign = (fee = ''): string => {
  return fee.includes('%') ? fee : `$${fee}`;
};


